module.exports = __webpack_public_path__ + "img/myPlace_main.f9b13c62.png";